import Axios from 'axios'
let axios = Axios.create()
let axiosRaw = Axios.create()

axios.interceptors.response.use((response)=>{
    if( response instanceof Error ){
        return Promise.reject(response.message)
    }else{
        return Promise.resolve(response.data)
    }
})
axiosRaw.interceptors.response.use((response)=>{
    if( response instanceof Error ){
        return Promise.reject(response)
    }else{
        return Promise.resolve(response)
    }
})

export default {
   stock: {
       pendingStores: (idClient) =>
            axios.get(`/api/stock/${idClient}/pending-stores`)
            
   }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/stockStoreUpdate/services/stockService.js